import { Col, Form, Input, Row, Select, Space, Typography } from "antd";
import React, { useEffect, useState } from "react";

import AppContainer from "~v2/components/AppContainer/AppContainer";
import { getOptions } from "../../../helpers/options";
import ViewTREs from "../../components/ViewTREs/ViewTREs";
import {
  getAllEstablishmentCategory,
  getEstablishment,
} from "../../http-request/establishment";
import styles from "./styles/ManageTREPage.module.css";

const { Text } = Typography;

const ManageTREPageView = () => {
  const [allEstablishment, setAllEstablishment] = useState([]);
  const [establishment, setEstablishment] = useState([]);
  const [categories, setcategories] = useState([]);

  const [forms] = Form.useForm();

  const loadEstablishments = async () => {
    const token = localStorage.getItem("token");
    await getEstablishment(token).then(({ establishments }) => {
      if (establishments.length > 0) {
        setAllEstablishment(establishments);
        setEstablishment(establishments);
      }
    });
  };

  const loadCategories = async () => {
    await getAllEstablishmentCategory().then(({ categories }) => {
      let _categories = getOptions({
        data: categories,
        value: "_id",
        label: "category",
      });
      _categories.push({ value: "All", label: "All" });
      setcategories(_categories);
    });
  };

  const onChangeSelection = (value) => {
    let _establishment = allEstablishment.filter((establishment) =>
      value !== "All" ? establishment.category._id === value : establishment
    );
    setEstablishment(_establishment);
  };

  const onChangeInput = (e) => {
    let _value = e.target.value.toLowerCase();
    let _establishment = allEstablishment.filter((establishment) =>
      establishment.name.toLowerCase().includes(_value)
    );
    setEstablishment(_establishment);
  };

  useEffect(() => {
    loadCategories();
    loadEstablishments();
  }, []);

  useEffect(() => {
    let categories = forms.getFieldValue("categories");
    forms.setFieldsValue({ input: "" });
    onChangeSelection(categories);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allEstablishment]);

  return (
    <AppContainer title="View User Accounts">
      <center>
        <div style={{ margin: "20px 0px", width: "80vw" }}>
          <Form form={forms} initialValues={{ categories: "All" }}>
            <Space
              direction="vertical"
              size={"middle"}
              style={{ width: "100%" }}
            >
              <Row align="middle">
                <Col span={8}>
                  <Text className={styles.alignLeft}>Search TRE:</Text>
                </Col>
                <Col span={16}>
                  <Form.Item name={"input"} style={{ margin: 0 }}>
                    <Input onChange={onChangeInput} />
                  </Form.Item>
                </Col>
              </Row>
              <Row align="middle">
                <Col span={8}>
                  <Text className={styles.alignLeft}>View by Category:</Text>
                </Col>
                <Col span={16}>
                  <Form.Item name={"categories"} style={{ margin: 0 }}>
                    <Select
                      onChange={onChangeSelection}
                      options={categories}
                      style={{ width: "100%", textAlign: "left" }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <ViewTREs
                establishments={establishment}
                loadEstablishments={loadEstablishments}
                categories={categories}
              />
            </Space>
          </Form>
        </div>
      </center>
    </AppContainer>
  );
};

export default ManageTREPageView;
